import { render, staticRenderFns } from "./DocumentSmall.vue?vue&type=template&id=2c2ead60"
import script from "./DocumentSmall.vue?vue&type=script&lang=js"
export * from "./DocumentSmall.vue?vue&type=script&lang=js"
import style0 from "./DocumentSmall.vue?vue&type=style&index=0&id=2c2ead60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports